import { render, staticRenderFns } from "./square-title.vue?vue&type=template&id=56c6968e&scoped=true&"
import script from "./square-title.vue?vue&type=script&lang=js&"
export * from "./square-title.vue?vue&type=script&lang=js&"
import style0 from "./square-title.vue?vue&type=style&index=0&id=56c6968e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6968e",
  null
  
)

export default component.exports